// extracted by mini-css-extract-plugin
export default {"kitchen-component-cell":"O5jwdHW659ygzvwJXtmK"};